import en from "./widgetLocaleBundles/en/tripper.json";
import es from "./widgetLocaleBundles/es/tripper.json";
import fr from "./widgetLocaleBundles/fr/tripper.json";

const TEXT_BUTTON_DEFAULT = {
  en: en.EMBED.TEXT_BUTTON_DEFAULT,
  es: es.EMBED.TEXT_BUTTON_DEFAULT,
  fr: fr.EMBED.TEXT_BUTTON_DEFAULT,
} as const;

/**
 * i18next returns the key path until the tripper namespace has been fetched.
 * The text button paints before that request finishes, so an unresolved key
 * must never be shown.
 */
export function isUnresolvedTripperTextButtonKey(value: string) {
  return value.includes("TEXT_BUTTON_DEFAULT");
}

export function resolveTripperTextButtonLabel(
  label: string | undefined,
  translated: string,
  language: string,
): string {
  if (label) return label;
  if (translated && !isUnresolvedTripperTextButtonKey(translated)) {
    return translated;
  }
  if (language === "es" || language === "fr") {
    return TEXT_BUTTON_DEFAULT[language];
  }
  return TEXT_BUTTON_DEFAULT.en;
}
